import { TypeValue } from '../../../types/SearchFilters';
import { FilterBuilder } from '../Types';

const propertyTypeBuilder: FilterBuilder = ({ categories = [] }, context) => {
  if (
    !categories.length ||
    categories.length === Object.keys(TypeValue).length ||
    context?.withoutPropertyType
  ) {
    return '';
  }

  const propertyArray = categories.reduce((array: string[], category) => {
    switch (category) {
      case TypeValue.PRIVATE_ROOM:
        return [...array, 'propertyType:PRIVATE_ROOM'];
      case TypeValue.SHARED_ROOM:
        return [...array, 'propertyType:SHARED_ROOM'];
      case TypeValue.APARTMENT:
        return [...array, 'propertyType:APARTMENT', 'propertyType:HOUSE'];
      case TypeValue.STUDIO:
        return [...array, 'propertyType:STUDIO'];
      default:
        return array;
    }
  }, []);

  if (propertyArray.length === 1) {
    return propertyArray[0];
  }
  if (propertyArray.length > 1) {
    return `(${propertyArray.join(' OR ')})`;
  }

  return '';
};

export default propertyTypeBuilder;
